import React from 'react';
import './Header.css';

const Header = ({ isAuthenticated, onLogout, isAdminPage }) => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="logo-section">
          <div className="snooker-ball"></div>
          <h1 className="club-name">Big Break Snooker Club</h1>
        </div>
        <div className="header-right">
          <div className="header-subtitle">Tournament Championship</div>
          {isAdminPage && isAuthenticated && (
            <button className="header-button logout-button" onClick={onLogout}>
              Logout
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
